<template>
  <div class="QuestionResponseList">
    <div class="table">
      <XTable
          ref="xTable"
          :api="getLessonQuestionResponseList"
          :state="questionResponseList"
          :columns="columns"
          :loading="questionResponseListLoading"
          :tableSize="tableSize"
          :layout="layout"
      ></XTable>
    </div>

    <AnswerQuestionModal :row="row" :isAnswer="isAnswer"></AnswerQuestionModal>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import {ANSWER_STATES} from "@/utils/constants";
import AnswerQuestionModal from "@/pages/QuestionManagement/AnswerQuestionModal.vue";
import DateUtil from "@/utils/formatDate";

export default {
  name: "QuestionResponseList",
  components: {AnswerQuestionModal, XTable},
  data() {
    return {
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      row: {},
      isAnswer: false,
    };
  },
  computed: {
    ...mapState("courseCenter", [
      "questionResponseListLoading",
      "questionResponseList",
      "answerQuestionModalVisible",
    ]),
    ...mapState("user", ["permissionCode"]),
    columns: function () {
      const self = this;
      const columns = [
        {
          prop: "id",
          label: "序号",
        },
        {
          prop: "classSubjectName",
          label: "系列名称",
        },
        {
          prop: "lessonName",
          label: "课程标题",
        },
        {
          label: "问题内容",
          render(h, scope) {
            return (
                <div>
                  <div class="textBox">
                    {(scope.row && scope.row.question) || "-"}
                  </div>
                </div>
            );
          },
        },
        {
          label: "回答",
          render(h, scope) {
            return (
                <div>
                  <div class="textBox">
                    {(scope.row && scope.row.answer) || "-"}
                  </div>
                </div>
            );
          },
        },
        {
          prop: "userName",
          label: "用户名",
        },
        // {
        //   prop: "questionTime",
        //   label: "提问日期",
        // },
        {
          label: "提问日期",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.questionTime)}</span>
                </div>
            );
          },
        },
        {
          label: "回答状态",
          render(h, scope) {
            return (
                <div>
                  <span>{ANSWER_STATES[scope.row.states]}</span>
                </div>
            );
          },
        },
      ];

      if (this.permissionCode.has('lesson:question:manager')) {
        columns.push({
          label: "操作",
          fixed: "right",
          width: 250,
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleView(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    查看
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleAnswer(scope.row);
                      }}
                      disabled={scope.row.states === 1}
                      size="mini"
                      type="primary"
                      plain
                  >
                    回答
                  </el-button>
                  {scope.row.openState !== 1 && (
                      <el-button
                          onClick={() => {
                            self.handleRecommend(scope.row);
                          }}
                          disabled={scope.row.states === 0}
                          size="mini"
                          type="primary"
                          plain
                      >
                        推荐
                      </el-button>
                  )}
                  {scope.row.openState === 1 && (
                      <el-button
                          onClick={() => {
                            self.handleCancelRecommend(scope.row);
                          }}
                          disabled={scope.row.states === 0}
                          size="mini"
                          type="primary"
                          plain
                      >
                        取消推荐
                      </el-button>
                  )}
                </div>
            );
          },
        })
      }
      return columns;
    }
  },
  beforeDestroy() {
    this.setData({key: "answerQuestionModalVisible", value: false});
  },
  methods: {
    ...mapActions("courseCenter", [
      "getLessonQuestionResponseList",
      "recommendLessonQuestion",
    ]),
    ...mapMutations("courseCenter", ["setData"]),
    handleView(row) {
      this.row = row;
      this.setData({
        key: "answerQuestionModalVisible",
        value: true,
      });
      this.isAnswer = false;
    },
    handleAnswer(row) {
      this.row = row;
      this.setData({
        key: "answerQuestionModalVisible",
        value: true,
      });
      this.isAnswer = true;
    },
    async handleRecommend(row) {
      await this.recommendLessonQuestion({
        id: row.id,
        openState: 1,
      });
      this.$message.success("推荐成功");
      this.$refs.xTable.pageChange();
    },
    async handleCancelRecommend(row) {
      await this.recommendLessonQuestion({
        id: row.id,
        openState: 0,
      });
      this.$message.success("已取消推荐");
      this.$refs.xTable.pageChange();
    },
    //   根据时间戳计算上传时间
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.QuestionResponseList {
  .table {
    ::v-deep .textBox {
      width: 100%;
      white-space: nowrap; /* 防止文本换行 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 超出部分显示省略号 */
    }
  }
}
</style>
